import type { ICellRendererParams } from 'ag-grid-community';
import { MdStorefront } from 'react-icons/md';
import type { Closure } from '../../schema';

/**
 * Compact pill showing the APMC count. Smart scope label ("All India" /
 * "All of Telangana") is out-of-scope for v1 — list returns count only.
 * Detail screen has the full list of affected APMCs.
 */
export function ApmcScopeCell(p: ICellRendererParams<Closure>) {
  if (!p.data) return null;
  const count = p.data.apmcCount;

  return (
    <span className="inline-flex w-fit shrink-0 items-center gap-1.5 self-center rounded-full bg-primary/[0.08] px-2 py-[3px] text-[11px] font-semibold leading-none text-primary ring-1 ring-inset ring-primary/15">
      <MdStorefront size={12} className="shrink-0" />
      {count} {count === 1 ? 'APMC' : 'APMCs'}
    </span>
  );
}
